import IBAN from 'iban';

import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';

export class IbanValidator extends BaseValidator {
    static key = 'iban';

    static validator(value, label = 'IBAN') {
        if (!value) {
            return true;
        }

        if (!IBAN.isValid(value)) {
            return i18n.t('validator.iban', { field: label });
        }

        return true;
    }

    static arguments() {
        return [];
    }
}

export default IbanValidator;
